import ReactDOM from 'react-dom';
import React from 'react';
import Explorer from './app';

ReactDOM.render(<Explorer/>, document.getElementById('app'))




// WEBPACK FOOTER //
// ./index.js